import { BaseWrapper, H2, H6 } from '@base'
import { Devices, Spacings, Text } from '@styles'
import styled, { css } from 'styled-components'

export const Wapper = styled.div`
	flex-direction: column;
	gap: ${Spacings.SPACING_5B};
	border-radius: ${Spacings.SPACING_10};
	display: flex;
	align-items: stretch;
`

export const DetailsWrapper = styled(BaseWrapper)`
	display: flex;
	gap: ${Spacings.SPACING_3B};
	padding: ${Spacings.SPACING_5B};
	flex-direction: column;
	align-items: flex-start;
	width: 100%;
`
export const SectionHeaderWapper = styled.div`
	padding-bottom: ${({ isFinancialHeader }) => (isFinancialHeader ? Spacings.SPACING_1 : Spacings.SPACING_3B)};
	margin: ${({ margin }) => margin};
	display: flex;
	align-items: center;
	line-height: ${Text.LINE_HEIGHT_MAX};
	gap: ${Spacings.SPACING_10};
	justify-content: space-between;
`

export const Heading = styled(H2)`
	color: ${({ theme }) => theme.palette.text.blackTwo};
	line-height: ${Text.LINE_HEIGHT_MAX};
	margin: ${({ margin }) => margin ?? 0};
	font-size: ${Text.X_LARGE};
	font-weight: ${Text.BOLD_600};
`
export const ButtonWapper = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: ${Spacings.SPACING_10};
`
export const IconWapper = styled.div`
	display: flex;
	padding: ${Spacings.SPACING_10};
	justify-content: center;
	align-items: center;
	gap: ${Spacings.SPACING_10};
	border-radius: ${Spacings.SPACING_10};
	// border: 1px solid var(--Gray-300, #d2d5db);
	// background: var(--White-text, #fff);
	cursor: pointer;
`

export const CardHeadingWapper = styled.div`
	display: flex;
	padding-bottom: ${Spacings.SPACING_10};
	justify-content: space-between;
	align-self: stretch;
	align-items: flex-start;
	@media (${Devices.mobile}) {
		align-items: center;
	}
`
export const CardHeading = styled.div`
	color: ${({ theme }) => theme.palette.text.blackTwo};
	font-size: ${Text.M_LARGE};
	font-style: normal;
	font-weight: ${Text.BOLD_600};
	line-height: ${Text.LINE_HEIGHT_MAX};
`

export const GridListWrapper = styled.div`
	display: grid;
	align-items: end;
	width: 100%;
	grid-template-columns: ${({ itemPerRow }) => `repeat(${itemPerRow?.[0] ?? 1}, 1fr)`};
	grid-gap: ${Spacings.SPACING_2B};
	@media (${Devices.mobile}) {
		grid-gap: ${Spacings.SPACING_8B};
	}
	@media (${Devices.tablet}) {
		grid-template-columns: ${({ itemPerRow }) => `repeat(${itemPerRow?.[1] ?? 2}, 1fr)`};
	}

	@media (${Devices.desktop}) {
		grid-template-columns: ${({ itemPerRow }) => `repeat(${itemPerRow?.[2] ?? 2}, 1fr)`};
	}
`

export const GridContainer = styled.div`
	display: flex;
	align-items: flex-start;
	align-content: ${({ AlignContent }) => (AlignContent ? 'center' : 'flex-start')};
	gap: ${Spacings.SPACING_7B};
	flex-wrap: wrap;
	width: 100%;
	${({ isRightBoder }) => {
		if (isRightBoder) {
			return css`
				border-right: none;
				@media (${Devices.mobile}) {
					border-right: 1px solid #e5e7ea;
				}
			`
		}
	}}
`
export const VerticalLine = styled.div`
	border-right: 1px solid #e5e7ea;
`

export const LabelWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.375rem;
	align-self: stretch;
	& > h6 {
		display: flex;
		align-items: baseline;
	}
`

export const DetailItemContainer = styled.div`
	width: 100%;
	padding-right: unset;
	@media (${Devices.mobile}) {
		padding-right: ${Spacings.SPACING_8B};
	}
`
export const Label = styled(H6)`
	color: ${({ theme }) => theme.palette.text.label};
	line-height: ${Text.LINE_HEIGHT_MAX};
	margin: ${({ margin }) => margin ?? 0};
`
export const TextValue = styled(H6)`
	font-size: ${Text.MEDIUM};
	font-weight: ${Text.BOLD_500};
	line-height: ${Text.LINE_HEIGHT_MAX};
`
export const ContainerWapper = styled.div`
	display: flex;
	align-items: stretch;
	gap: ${Spacings.SPACING_5B};
	flex-direction: column;
	@media ${Devices.tablet} {
		flex-direction: row;
	}
`
export const FormGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 16px;
`
export const FullWidth = styled.div`
	grid-column: span 2;
`

export const PsuedoWrapper = styled.div`
	position: sticky;
	bottom: 0;
	z-index: 1;
	background: ${({ theme }) => theme.palette.background.searchgrey};
	border-top: 1px solid ${({ theme }) => theme.palette.background.searchgrey};

	@media ${Devices.tablet} {
		margin: 0 -${Spacings.SPACING_4B};
	}
`

export const CreateFooter = styled.div`
	padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
	background: ${({ theme }) => theme.palette.background.white};
	box-shadow: 0 ${Spacings.SPACING_1B} ${Spacings.SPACING_5B} 0 rgb(0 0 0 / 5%);
	display: flex;
	flex-direction: column;
`

export const ButtonsWrapper = styled.div`
	display: flex;
	margin: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
	justify-content: flex-end;
	gap: ${Spacings.SPACING_3B};
	@media ${Devices.tablet} {
		margin: ${Spacings.SPACING_3B} 0;
	}
	@media ${Devices.desktop} {
		margin: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
	}
`
export const TitleWapper = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	flex-direction: column;
	align-items: flex-start;
	@media (${Devices.mobile}) {
		flex-direction: row;
		align-items: baseline;
	}
`

export const EmptyState = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: ${Spacings.SPACING_5B};
	background: ${({ theme }) => theme.palette.background.searchgrey};
	color: ${({ theme }) => theme.palette.text.blackTwo};
	font-size: ${Text.LARGE};
	line-height: ${Text.LINE_HEIGHT_MAX};
	text-align: center;
`